import { CloseSquare } from "iconsax-react";

export const CMSSheet = ({
  isOpen,
  onClose,
  title,
  desc,
  children,
  onSave,
  onCancel,
  saveButtonText = "Create",
  cancelButtonText = "Cancel",
  isLoading = false,
  isSaveDisabled = false,
}) => {
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40"
        ></div>
      )}

      <div
        className={`${
          isOpen ? "block" : "hidden"
        } fixed w-full max-w-[50%] top-0 right-0 bottom-0 z-50 h-screen bg-white flex flex-col`}
      >
        <div className="px-5 py-4 flex justify-between items-start flex-shrink-0">
          <div className="space-y-2">
            <h1 className="text-lg font-medium select-none">{title}</h1>
            <p className="text-sm text-[#6D6D6D]">{desc}</p>
          </div>
          <button onClick={onClose || onCancel}>
            <CloseSquare variant="Bold" size={28} />
          </button>
        </div>

        <div className="px-5 py-6 flex-1 overflow-y-auto scrollbar-hide">
          {children}
        </div>

        <div className="sticky bottom-0 bg-white border-t border-gray-200 px-5 py-4 flex-shrink-0">
          <div className="flex justify-end gap-3">
            <button
              onClick={onCancel || onClose}
              disabled={isLoading}
              className="px-6 py-2.5 border border-gray-300 rounded-md text-[14px] font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300"
            >
              {cancelButtonText}
            </button>
            <button
              onClick={onSave}
              disabled={isSaveDisabled || isLoading}
              className="px-6 py-2.5 bg-primary text-white rounded-md text-[14px] font-medium hover:opacity-80 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 transition-all duration-300"
            >
              {isLoading && (
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              )}
              {saveButtonText}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
